module.exports = __webpack_public_path__ + "media/images/webpage/hotels/cover-lclxicotto-237c947b3a722d90742421e634206257.webp";